import { Component } from '@angular/core';
import { LaunchService } from 'src/app/services/launchpad.service';
@Component({
  selector: 'app-trading-contest',
  templateUrl: './trading-contest.component.html',
  styleUrls: ['./trading-contest.component.css']
})

export class TradingContestComponent {



  imageUrls: string[] = [];

 
  ngOnInit() {
    // Simulating backend API response
    this.fetchImages();
    this.getLaunchPad(); 
  }

  fetchImages() {
    // Replace with actual API call if needed
    this.imageUrls = [
      "/assets/images/tradingcontest1.jpg",
      "/assets/images/tradingcontest2.jpg",
      "/assets/images/tradingcontest3.jpg",
      "/assets/images/tradingcontest4.jpg",
    ];
  }

  data: any = 'upcoming';
  launchData: any = [];
  constructor(private LaunchService: LaunchService) {}
  onInputChange(event: Event) { 
    const eventData = (event.target as HTMLInputElement).name;
    this.data = eventData;
    this.getLaunchPad();
  }


  getLaunchPad() {
    // this.LaunchService.getLaunchData(this.data).subscribe({
    //   next: (v: any) => {
    //     if (v.success) {
    //       this.launchData = v.result.data;
    //     }
    //   },
    //   error: (err) => {},
    // });
  }
}
